<template>
  <BaseIndex
    ref="baseIndex"
    :modelNameSingular="modelNameSingular"
    :modelNamePlural="modelNamePlural"
    :pageLoading="pageLoading"
    :loading="loading"
    :table-headers="tableHeaders"
    :table-items="items"
    :indexNested="true"
    :maskFields="maskFields"
    :disablePagination="true"
    :hasTableTitle="hasTableTitle"
    :tableTitle="tableTitle"
    :showExpand="true"
    :customExpandIcon="true"
    @row-clicked="handleRowClicked"
    class="row-pointer"
    :containSearchBar="false"
  >
   
    <template slot="new" v-if="$can('create', $router.currentRoute.name)">
      <New
        @entry-created="entryCreated"
        :modelNameSingular="modelNameSingular"
        :extraData="extraData"
      />
    </template>

    <template slot="edit" slot-scope="{ item }" v-if="$can('update', $router.currentRoute.name)">
      <Edit
        :entry="item"
        @entry-updated="entryUpdated"
        :modelNameSingular="modelNameSingular"
        :extraData="extraData"
        :isEdit="true"
      />
    </template>

    <template slot="delete" slot-scope="{ item }" v-if="$can('delete', $router.currentRoute.name)">
      <Delete
        :entry="item"
        @entry-destroyed="entryDeleted"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template v-slot:expand="{ item, headers }">
      <td :colspan="headers.length" :class="'px-0 px-sm-2 px-md-6 mt-3 ' + ($vuetify.breakpoint.smAndDown ? 'v-data-table__mobile-row': '')">
        <BuildingLevelBoxIndex
          v-if="true"          
          :hasTableTitle="false"
          :hasTopMenu="false"
          :loading="false"
          :extraData="extraData"
          :items.sync="item.buildingLevelBoxesAttributes"
          class="mt-6"                   
          :readOnly="readOnly"          
        />
      </td>
    </template>  

    <template v-slot:expandColumn="{ item, isExpanded, expand }">
      <v-btn text color="primary" v-if="!isExpanded">Ver Boxes</v-btn>
      <v-btn text color="primary" v-if="isExpanded"><v-icon left>mdi-eye-off</v-icon>Boxes</v-btn>
    </template>

  </BaseIndex>
</template>

<script>
import BaseIndex from "@shared_components/base_index.vue";
import BuildingLevelBoxIndex from "@models/storage_shelves/storage_buildings/building_levels/building_level_boxes/index.vue"
import New from "./new.vue";
import Edit from "./edit.vue";
import Delete from "./delete.vue";

export default {
  data() {
    return {
      loading: false,
      pageLoading: false,
      indexKey: 1,
      // tableHeaders: [],
      maskFields: [
        // { field: 'averageUnitPrice', mask: 'currency_10d' }, 
        // // { field: 'purchaseQuantity', mask: 'number'},
        // { field: 'availableQuantity', mask: 'number'}, 
        // { field: 'movementItemAvailableQuantity', mask: 'number'},
        // // { field: 'totalPrice',mask: 'currency'},
        // { field: 'availableTotalPrice', mask: 'currency' }
      ]
    };
  },
  components: {
    BaseIndex: BaseIndex,
    BuildingLevelBoxIndex: BuildingLevelBoxIndex,
    New: New,
    Edit: Edit,
    Delete: Delete,
  },
  props: {
    extraData: {},
    items: {
      type: Array,
      default: () => [],
    },
    readOnly: {
      type: Boolean,
      default: false
    },   
    hasTableTitle: {
      type: Boolean,
      default: false
    },
    tableTitle: {
      type: String
    },
    modelNameSingular: {
      type: String,
      default: "Nível/Andar"
    },
    modelNamePlural: {
      type: String,
      default: "Níveis/Andares"
    },
    allItems: {
      type: Array,
      default: () => [],
    },
  },
  created() {
    console.log("lvl index", this.extraData);
  },
  computed: {
    tableHeaders() {
      var indexTable = [
        { text: "Nome", align: "left", sortable: true, value: "name" },
        // { text: "Andar", align: "left", sortable: true, value: "floor" },
        { text: "Ações", value: "action", sortable: false }
      ];
      // console.log("enabled", this.enabledLots);
        // if (this.enabledLots){          
        //   indexTable.push({ text: "Lotes", value: "data-table-expand", sortable: false },);
        // }      
        return indexTable;
    }
  },
  methods: {
    entryUpdated: function(editedStorageItem){
      this.$refs.baseIndex.showConfirmationUpdateMessage();      
      // this.recalculatePurchaseTotalPrice();
      // this.shelves.push(editedStorageItem);
    },
    entryCreated: function(newStorageItem){
      console.log("ecreated", newStorageItem);
      this.items.push(newStorageItem);
      this.$refs.baseIndex.showConfirmationCreateMessage();
      // this.recalculatePurchaseTotalPrice();
    },
    entryDeleted: function(deletedStorageItem){
      console.log("del", deletedStorageItem);
      // this.$refs.baseIndex.showConfirmationDeleteMessage();
      // this.recalculatePurchaseTotalPrice();
    },
    handleRowClicked: function(rowArguments) {
      console.log("row click", rowArguments);
      if (rowArguments && rowArguments[1]) {
        rowArguments[1].expand(!rowArguments[1].isExpanded);
      }
    }
  }
};
</script>

<style lang="css" scoped>
  .row-pointer >>> tbody tr :hover {
    cursor: pointer;
  }
</style>
